import { AsyncThunkAction } from 'actions/actions.types'
import { fetchPhotoRatingActiveListPhotoAction } from 'actions/featuredPhotosAction'
import {
  setFeaturedActivePhotosAction,
  setUpPromoAction,
} from 'actions/rating/promoAction'
import { RatingPromo } from 'components/page/PhotoRating/PhotoRating.constants'

export const checkFeaturedPhotosActiveAction =
  (): AsyncThunkAction => async (dispatch, getState) => {
    await dispatch(fetchPhotoRatingActiveListPhotoAction(true)).then((data) => {
      const hasActiveFeaturedPhotos = (
        data && Array.isArray(data.result) ? data.result || [] : []
      )
        .map((photo) => photo.status)
        .includes('active')

      if (
        hasActiveFeaturedPhotos &&
        getState().photoRatingReducer.currentPromo === RatingPromo.featured
      ) {
        dispatch(setUpPromoAction())
      }

      dispatch(setFeaturedActivePhotosAction(hasActiveFeaturedPhotos))
    })
  }
